export default {
    'Restore Password': 'Відновлення паролю',
    'Restore Password Button': 'Скинути пароль',
    'Restore Password Text': 'Для відновлення паролю вкажи свою електрону адресу',
    'Email': 'Email',
    'Email Placeholder': 'Введи свій email',
    'Back to login': 'Назад до авторизації',
    'Restore': 'Відновити',
    'Timezone': 'Часовий пояс',
    'Language': 'Мова',
    'Avatar': 'Аватар',
    'SystemDefaultLanguage': 'Мова системи за замовчуванням',
    'Name': 'Ім\'я',
    'Surname': 'Прізвище',
    'Save Changes': 'Зберегти зміни',
    'restoreStatusTextFirst': 'Запит на скидання пароля надіслано.',
    'restoreStatusTextSecond': 'Незабаром ви отримаєте електронний лист.',
    'restoreStatusTextErrorFirst': 'Ми не змогли знайти цю електрону адресу.',
    'restoreStatusTextErrorSecond': 'Перевірте введені дані та повторіть спробу.',
    'New Password Title': 'Відновлення паролю',
    'New Password': 'Новий пароль',
    'New Password Placeholder': 'Введи свій пароль',
    'Confirm Password Placeholder': 'Введи свій новий пароль',
    'Confirm new password': 'Підтвердити новий пароль',
    'There are no classes this week': 'На обраному тижні нема занять',
    'Notifications': 'Сповіщення',
    'Mark as read': 'Позначити як прочитане',
    'Unread': 'Непрочитані',
    'It has not been implemented yet': 'Це ще не реалізовано',
    'Left a comment to': 'Залишив/ла коментар',
    'Checked': 'Перевірено',
    'online lesson': 'онлайн-урок',
    'Connect here': 'Підключитися тут',
    'rated the': 'оцінив/ла',
    'opened access to the': 'Ви маєте доступ до',
    'new module': 'нового модулю',
    'returned the test': 'повернув/ла тест',
    'back to work': 'назад до роботи',
};
